"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const services_1 = require("../services");
const collection_edit_model_1 = require("../store/collection.edit.model");
const page_state_1 = require("./page.state");
class CollectionEditState {
    constructor(collection) {
        this.collectionRevision = null;
        this.collection = null;
        this.draw = mobx_1.observable.map({}, { deep: false });
        if (collection == null) {
            this.collectionRevision = null;
            return;
        }
        this.collectionRevision = collection.revision;
        this.editState = collection.beginEdit(state => new collection_edit_model_1.CollectionModelStateEdit(state));
        this.collection = collection;
    }
    reset() {
        var _a;
        (_a = this.editState) === null || _a === void 0 ? void 0 : _a.reset();
    }
    revert(fieldId) {
        var _a;
        (_a = this.editState) === null || _a === void 0 ? void 0 : _a.fields.delete(fieldId);
    }
    isFieldDirty(fieldId) {
        var _a;
        return (_a = this.editState) === null || _a === void 0 ? void 0 : _a.fields.has(fieldId);
    }
    get isDirty() {
        var _a;
        return this.collectionRevision != null && ((_a = this.editState) === null || _a === void 0 ? void 0 : _a.isDirty);
    }
    get isEditing() {
        return this.collectionRevision != null;
    }
    get currentDraw() {
        const inspectedCapture = page_state_1.CurrentState.inspectedCaptureId;
        if (inspectedCapture == null) {
            return null;
        }
        return this.getIkeDraw(inspectedCapture);
    }
    getIkeDraw(captureId) {
        let existing = this.draw.get(captureId);
        if (existing != null) {
            return existing;
        }
        if (!this.collection) {
            throw new Error('Collection must be set before getting IkeDraw from CollectionEditState');
        }
        const drawState = services_1.Services.DrawState.createIkeDraw(this.collection, captureId);
        this.draw.set(captureId, drawState);
        return drawState;
    }
    cancelLinkFields() {
        this.draw.forEach(draw => draw.state.setLinkFields(null));
    }
}
exports.CollectionEditState = CollectionEditState;
tslib_1.__decorate([
    mobx_1.action
], CollectionEditState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionEditState.prototype, "revert", null);
//# sourceMappingURL=collection.edit.state.js.map